import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Package} from "../../../model/package";
import {ProductService} from "../../../service/product.service";

@Component({
  selector: 'app-package-mobile',
  templateUrl: './package-mobile.component.html',
  styleUrls: ['./package-mobile.component.css']
})
export class PackageMobileComponent implements OnInit {

  constructor(private productService: ProductService) { }
  @Output() selectEvent = new EventEmitter();
  @Input() package: Package;
  @Input() hasAdditional = '';
  hasDocument: string;
  mobile: boolean = false;

  ngOnInit(): void {
    if (window.screen.width <= 1000) { // 768px portrait
      this.mobile = true;}
  }


}
